import { reducer } from './reducer';
import { OPTIMIZATION_NAMESPACE } from './constants';

export default {
  [OPTIMIZATION_NAMESPACE]: reducer,
};
